import React, { memo, useContext } from 'react'

import { bool, func, string } from 'prop-types'

import UpgradeCard from 'Pods/Shared/Waitlist/UpgradeCard/UpgradeCard'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'
import ThreeDStudioPageContext from 'Pods/ThreeDStudio/ThreeDStudioPageContext'

import AdvancedFeaturesList from '../AdvancedFeaturesList/AdvancedFeaturesList'
import { buildSubscriptionHref, TODO_LEARN_MORE_HREF } from '../constants'

// Store adapter for the shared UpgradeCard: reads the hydrated subscription values from the studio
// store and feeds them to the store-agnostic presentational card.
function UpgradeCardContainer({ onClose: handleClose, title = '', showAdvancedFeaturesList = false }) {
  const t = useTranslation()
  const { locale } = useContext(ThreeDStudioPageContext)
  const subscriptionPrice = useThreeDStudioStore(state => state.subscription.subscriptionPrice)
  const subscriptionOriginalPrice = useThreeDStudioStore(
    state => state.subscription.subscriptionOriginalPrice
  )
  const subscriptionMonthlyModels = useThreeDStudioStore(
    state => state.subscription.subscriptionMonthlyModels
  )
  const subscriptionPaymentFormUrl = useThreeDStudioStore(
    state => state.subscription.subscriptionPaymentFormUrl
  )

  return (
    <UpgradeCard
      title={title || t('usageModal.upgradeCard.defaultTitle')}
      price={subscriptionPrice}
      originalPrice={subscriptionOriginalPrice}
      monthlyModels={subscriptionMonthlyModels}
      subscriptionHref={buildSubscriptionHref(subscriptionPaymentFormUrl)}
      learnMoreHref={TODO_LEARN_MORE_HREF}
      onClose={handleClose}
      locale={locale}
      advancedFeaturesList={showAdvancedFeaturesList ? <AdvancedFeaturesList locale={locale} /> : null}
      showAdvancedFeaturesBullet={!showAdvancedFeaturesList}
    />
  )
}

UpgradeCardContainer.propTypes = {
  onClose: func.isRequired,
  title: string,
  showAdvancedFeaturesList: bool,
}

export default memo(UpgradeCardContainer)
